import React, { Fragment, useState, useEffect, useContext } from "react";

import { makeStyles } from "@material-ui/styles";

import { Typography, Grid, Paper, Button } from "@material-ui/core";
import Logincomp from "../../Component/Layout/Logincomp";
import Registercomp from "../../Component/Layout/Registercomp";
import bgimage from "../../images/graphic-icon/login_background.png";
import useReactRouter from "use-react-router";
import { LangContext } from "../../Context/Langcontext";
import { TiArrowLeft } from "react-icons/ti";
import Resetpassword from "./resetpassword";

const useStyle = makeStyles((theme) => ({
  root: { width: "100%", height: "100%" },
  Position: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  PaperRight: {
    height: "100%",
    // borderRadius: "2rem",
    boxShadow: "unset",
    // backgroundColor: "rgba(255,255,255,0.5)"
  },
  PaperSize: {
    width: "100vw",
    height: "100vh",
    // borderRadius: "2rem",
    // background:
    //   "linear-gradient(210deg, rgba(240, 111, 116,1) 50%, rgba(243, 141, 64,1) 100%)",
    backgroundImage: `url(${bgimage})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
  },

  LeftText: { color: "white" },
  input: {
    color: "black",
  },
  card: {
    padding: theme.spacing(3, 2),
    minWidth: 500,
  },

  headerContent: {
    textAlign: "center",
  },
  itemTextField: { width: "calc(100% )" },
  boxstyle: {
    borderRadius: theme.spacing(4),
    fontFamily: "Kanit-Light",
    fontSize: "0.8rem",
  },
  selectInput: { padding: theme.spacing(1) },

  noSpace: {
    padding: 0,
    margin: 0,
  },
  focusIcon: {
    color: theme.palette.primary.main,
  },
  blurIcon: {
    color: "rgba(0,0,0,0.5)",
  },
  signupText: {
    color: theme.palette.primary.main,
    textDecoration: "unset",
  },
  forgotText: {
    "& a": {
      color: theme.palette.error.main,
      textDecoration: "unset",
    },
  },
  extendedIcon: { marginRight: 8 },
  fab: {
    textTransform: "unset",
    background:
      "linear-gradient(90deg, rgba(102,208,240,1)  30%, rgba(129,244,162,1) 90%)",
    width: "100%",
    boxShadow: "unset",
  },
  gridSignin: { display: "flex" },
  center: { textAlign: "center" },
  nmtext: { fontWeight: 400, paddingRight: "0.5rem" },
  underline: {
    fontWeight: 400,
    textDecoration: "underline",
    paddingRight: "0.5rem",
    cursor: "pointer",
  },
  leftComp: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  rightComp: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
  },
  bottomComp: {
    display: "flex",
    padding: "1rem",
    flexWrap: "wrap",
  },
  bgcomp: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    [theme.breakpoints.up("lg")]: {
      display: "block",
    },
  },
  backhome: {
    transition: "transform .2s",
    "&:hover": {
      transform: "scale(1.8)",
    },
  },
  buttonbackhome: {
    textTransform: "unset",

    "&:hover": {
      boxShadow: "unset",
    },
  },
  backtext: {
    fontWeight: 400,
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    [theme.breakpoints.up("lg")]: {
      display: "block",
    },
  },
}));

const Login = () => {
  const classes = useStyle();
  const [page, setpage] = useState(0);
  const { location, history } = useReactRouter();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;

  useEffect(() => {
    if (location.pathname === "/user/register") {
      setpage(1);
    } else {
      setpage(0);
    }
  }, [location.pathname]);
  return (
    <Fragment>
      {/* <div className={classes.Position}> */}
      <Paper className={classes.PaperSize}>
        <Grid container className={classes.root}>
          <Grid item lg={7} md={12} sm={12} className={classes.bgcomp}>
            <div className={classes.leftComp}></div>
          </Grid>

          <Grid item lg={5} md={12} sm={12}>
            <Paper className={classes.PaperRight}>
              <div style={{ position: "absolute", margin: "0.5rem" }}>
                <Button
                  size="large"
                  onClick={() => {
                    history.push("/home");
                  }}
                  className={classes.buttonbackhome}
                  startIcon={
                    <TiArrowLeft className={classes.backhome} size={28} />
                  }
                >
                  <Typography
                    variant="h6"
                    component="p"
                    color="textPrimary"
                    className={classes.backtext}
                  >
                    กลับสู่หน้าหลัก
                  </Typography>
                </Button>
              </div>
              <div className={classes.rightComp}>
                {!page ? (
                  location.pathname === "/user/login" ? (
                    <Logincomp setpage={setpage} />
                  ) : (
                    <Resetpassword setpage={setpage} />
                  )
                ) : (
                  <Registercomp setpage={setpage} />
                )}

                <div className={classes.bottomComp}>
                  <Typography
                    variant="h6"
                    component="p"
                    className={classes.nmtext}
                  >
                    {lang.BySignin}
                  </Typography>
                  <Typography
                    variant="h6"
                    component="p"
                    className={classes.underline}
                    onClick={() => {
                      history.push("/privacy");
                    }}
                  >
                    {lang.PrivacyPolicy}
                  </Typography>

                  <Typography
                    variant="h6"
                    component="p"
                    className={classes.nmtext}
                  >
                    {lang.And.toLowerCase()}
                  </Typography>
                  <Typography
                    variant="h6"
                    component="p"
                    className={classes.underline}
                    onClick={() => {
                      history.push("/term");
                    }}
                  >
                    {lang.TermCondition}
                  </Typography>
                </div>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </Paper>
      {/* </div> */}
    </Fragment>
  );
};

export default Login;
